import { render } from "./Claim4_Eval.vue?vue&type=template&id=8ee14df6&scoped=true"
import script from "./Claim4_Eval.vue?vue&type=script&lang=js"
export * from "./Claim4_Eval.vue?vue&type=script&lang=js"

import "./Claim4_Eval.vue?vue&type=style&index=0&id=8ee14df6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8ee14df6"

export default script